import { Component } from '@verndale/core';

class PrimaryNav extends Component {
  setupDefaults() {
    this.dom = {
      wrapper: this.el.querySelector('.primary-nav__wrapper'),
      close: this.el.querySelector('.primary-nav__close'),
      navButtons: Array.from(this.el.querySelectorAll('.primary-nav-button')),
      navLinks: Array.from(this.el.querySelectorAll('.primary-nav-link')),
      menuDrawers: Array.from(
        this.el.querySelectorAll('.primary-nav-menu__drawer')
      )
    };
    this.updateMenuDrawers();
  }

  addListeners() {
    if (this.dom.close) {
      this.dom.close.addEventListener('click', ::this.close);
    }

    this.dom.navButtons.forEach(btn =>
      btn.addEventListener('click', ::this.toggleMenu)
    );

    window.addEventListener('resize', ::this.updateMenuDrawers);
    document.addEventListener('click', ::this.handleClickOutside);
    this.el.addEventListener('click', ::this.handleClose);
  }

  open() {
    this.el.classList.add('primary-nav--active');
    document.body.classList.add('nav--active');
  }

  close() {
    this.el.classList.remove('primary-nav--active');
    document.body.classList.remove('nav--active');
  }

  ariaStateButtons(button, menu) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const menuContainer = menu.querySelector('.primary-nav-menu__drawer');

    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      menuContainer.setAttribute('aria-hidden', 'true');
      return;
    }

    button.setAttribute('aria-expanded', 'true')
    menuContainer.setAttribute('aria-hidden', 'false');
  }

  toggleMenu(e) {
    const navButton = e.currentTarget;
    navButton.blur();
    const menu = navButton.parentNode;

    this.ariaStateButtons(navButton, menu);

    if (this.dom.activeMenu && this.dom.activeMenu !== menu) {
      this.closeActiveMenu();
    }
    if (menu.classList.contains('primary-nav-menu--active')) {
      this.closeMenu(menu);
    } else {
      this.openMenu(menu, navButton);
    }
  }

  closeActiveMenu() {
    if (this.dom.activeMenu) {
      this.closeMenu(this.dom.activeMenu);
      this.ariaStateButtons(this.dom.activeButton, this.dom.activeMenu)
    }
  }

  openMenu(menu, navButton) {
    menu.classList.add('primary-nav-menu--active');
    this.dom.activeMenu = menu;
    this.dom.activeButton = navButton;
  }

  closeMenu(menuItem) {
    menuItem.classList.remove('primary-nav-menu--active');
    this.dom.activeMenuItem = null;
  }

  updateMenuDrawers() {
    const { relativeEl } = this.props;
    if (relativeEl) {
      this.dom.menuDrawers.forEach(drawer => {
        drawer.style.minWidth = `${relativeEl.clientWidth}px`;
      });
    }
  }

  handleClose(e) {
    const target = e.target;
    if (this.dom.wrapper.contains(target)) {
      return;
    }
    this.close();
  }

  handleClickOutside(e) {
    if (this.isClickOutside(e.target)) {
      this.closeActiveMenu();
    }
  }

  isClickOutside(target) {
    const navButton = this.dom.navButtons.find(btn => btn.contains(target));
    if (navButton) {
      return false;
    }

    const navLink = this.dom.navLinks.find(link => link.contains(target));
    if (navLink) {
      return true;
    }

    if (!this.dom.activeMenu) {
      return false;
    }

    const activeMenuDrawer = this.dom.activeMenu.querySelector(
      '.primary-nav-menu__drawer'
    );
    if (activeMenuDrawer.contains(target)) {
      return false;
    }

    return true;
  }
}

export default PrimaryNav;
